import { PartnerConfigPartBaseResponse } from '../getPartnerConfig/getPartnerConfig.types'

export enum PartnerDonationMatchingConfigKeys {
  FamilialDonationMatching = 'familial_donation_matching',
  DirectToCampaignMatchRequests = 'direct_to_campaign_match_requests',
  DonationDateEligibility = 'donation_date_eligibility',
  SelfServeMatching = 'self_serve_matching'
}

export type PartnerFamilialDonationMatchingConfig = PartnerConfigPartBaseResponse & {
  key: PartnerDonationMatchingConfigKeys.FamilialDonationMatching
  value: {
    enabled: boolean
  }
}

export type PartnerSelfServeMatchingConfig = PartnerConfigPartBaseResponse & {
  key: PartnerDonationMatchingConfigKeys.SelfServeMatching
  value: {
    enabled: boolean
  }
}

export type PartnerDirectToCampaignMatchRequestsConfig = PartnerConfigPartBaseResponse & {
  key: PartnerDonationMatchingConfigKeys.DirectToCampaignMatchRequests
  value: {
    enabled: boolean
  }
}

export type PartnerDonationDateEligibilityConfig = PartnerConfigPartBaseResponse & {
  key: PartnerDonationMatchingConfigKeys.DonationDateEligibility
  value: {
    enabled: boolean
    // Open-ended: the backend may return source types beyond the current 'startDate'.
    source?: { type: string }
  }
}

export type GetPartnerDonationMatchingConfigResponse = {
  data: {
    [PartnerDonationMatchingConfigKeys.FamilialDonationMatching]?: PartnerFamilialDonationMatchingConfig
    [PartnerDonationMatchingConfigKeys.DirectToCampaignMatchRequests]?: PartnerDirectToCampaignMatchRequestsConfig
    [PartnerDonationMatchingConfigKeys.DonationDateEligibility]?: PartnerDonationDateEligibilityConfig
    [PartnerDonationMatchingConfigKeys.SelfServeMatching]?: PartnerSelfServeMatchingConfig
  }
  object: string
}
